module.exports = __webpack_public_path__ + "img/cheerz.836a72d5.png";